<template>
  <div class="tw-relative tw-inline-block" v-click-outside="() => (isDropdownOpen = false)">
    <div
      @click="isDropdownOpen = !isDropdownOpen"
      :class="showBackground === true ? 'hover:tw-bg-gray-100' : ''"
      class="tw-px-4 tw-py-2 tw--mx-4 tw--my-2 tw-rounded-md tw-transition-colors tw-duration-100 tw-ease-in-out"
    >
      <slot>
        <base-button :color="color" :type="type">{{ label }}</base-button>
      </slot>
    </div>
    <transition
      enter-active-class="tw-transition tw-ease-out tw-duration-100"
      enter-class="tw-transform tw-opacity-0 tw-scale-95"
      enter-to-class="tw-transform tw-opacity-100 tw-scale-100"
      leave-active-class="tw-transition tw-ease-in tw-duration-75"
      leave-class="tw-transform tw-opacity-100 tw-scale-100"
      leave-to-class="tw-transform tw-opacity-0 tw-scale-95"
    >
      <div
        v-show="isDropdownOpen"
        :class="
          `tw-origin-top-${align} tw-absolute tw-${align}-0 tw-mt-2 tw-w-${width} tw-rounded tw-shadow-lg tw-z-40 tw-ring-1 tw-ring-black tw-ring-opacity-5 tw-max-h-96 tw-overflow-auto`
        "
      >
        <div class="tw-py-1 tw-rounded tw-bg-white tw-shadow-xs tw-text-base tw-font-normal">
          <div
            class="tw-text-gray-600 hover:tw-bg-gray-100 tw-cursor-pointer tw-text-sm"
            v-for="option in options"
            @click="option.onClick && option.onClick(), (isDropdownOpen = false)"
            :key="option.label"
          >
            <slot name="option" v-bind:option="option">
              <div class="tw-py-2 tw-px-4">{{ option.label }}</div>
            </slot>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    label: String,
    options: {
      type: Array,
      required: true,
    },
    type: String,
    color: String,
    align: {
      type: String,
      default: "left",
    },
    showBackground: { type: Boolean, default: true },
    width: {
      type: String,
      default: "48",
    },
  },
  data() {
    return {
      isDropdownOpen: false,
    };
  },
};
</script>
